import { GaleriaBig, GaleriaIcons } from "@/galeria/Galeria";
import { useAppContext } from "@/state/appContext";
import { fotoURL } from "@/helpers/foto";
import type { Foto, Usuario } from "@/state/types";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute("/_app/pedidos")({
  component: PedidosPage,
});

function PedidosPage() {
  const status = useAppContext(true);
  const usuario = status.state.usuario;

  const fotos = favoritas(usuario);

  const pedidos = useMemo(
    () =>
      Object.values(usuario.pedidos).sort(({ fecha: a }, { fecha: b }) =>
        cmp(b || "", a || "")
      ),
    [usuario.pedidos]
  );

  return (
    <div>
      <h2>Pedidos</h2>
      <div id="pedidos">
        {pedidos.map((p) => {
          var fotos = p.fotos.filter((f) => f.cantidad);
          var l = fotos.length;
          return (
            l > 0 && (
              <Link to="/pedido" search={{ id: p.id }}>
                <div
                  key={p.id}
                  style={{
                    textAlign: "center",
                    width: 200,
                    marginBottom: "20px",
                  }}
                >
                  <div className="pedido" style={{ padding: 10 }}>
                    <img src={fotoURL(fotos[p.id % l], "small")} height="100" />
                  </div>
                  <div>
                    {p.codLocal} {p.id % 10000}
                    <br />
                    {p.fecha} ({l})<br />
                    {p.pagado ? null : "OPEN"}
                    <br />
                  </div>
                </div>{" "}
              </Link>
            )
          );
        })}
      </div>
      <hr style={{ clear: "both" }} />
      <GaleriaBig fotos={fotos} icons={GaleriaIcons} />
    </div>
  );
}

function favoritas(usuario: Usuario) {
  // TODO: usuario deberia estar estructurado distinto, hay que normalizar primero y despues reformar el backend

  const fotos = new Map<number, Foto>();

  Object.values(usuario.pedidos).forEach((p) =>
    p.fotos.forEach((f) =>
      fotos.set(f.i, {
        ...f,
        cantidad: (fotos.get(f.i)?.cantidad ?? 0) + (f.cantidad ?? 0),
      })
    )
  );
  return [...fotos.values()]
    .filter((f) => !f.cantidad)
    .sort(
      (a, b) =>
        b.y - a.y ||
        Number(b.m) - Number(a.m) ||
        Number(b.d) - Number(a.d) ||
        cmp(b.h, a.h) ||
        b.i - a.i
    );
}

function cmp<T>(a: T, b: T) {
  return a < b ? -1 : a > b ? 1 : 0;
}
